import { createI18n } from 'vue-i18n'
import tw from './message/tw'
import en from './message/en'

const i18n = createI18n({
  locale: localStorage.getItem('lang') || 'tw', // 默认显示的语言
  fallbackLocale: localStorage.getItem('lang') || 'tw', // 预设语言环境
  globalInjection: true, // 全局生效$t
  legacy: false,
  messages: {
    tw: tw,
    en: en
  }
})

export default i18n
